export const presentationCredentialConstants = {
    VERIFY_CREDENTIAL_REQUEST: 'VERIFY_CREDENTIAL_REQUEST',
    VERIFY_CREDENTIAL_SUCCESS: 'VERIFY_CREDENTIAL_SUCCESS',
    VERIFY_CREDENTIAL_FAILURE: 'VERIFY_CREDENTIAL_FAILURE',
    VERIFY_CREDENTIAL_RESET: "VERIFY_CREDENTIAL_RESET"
  
  }
  